<template>
	<div class="_feed_item__message">
		<md-card
			:id="message.id"
			:key="message.id"
			class="message-viewport"
			:class="[
        manualCase ? 'outgoing' : message.replyToMessageId? 'outgoing' : 'incoming',
        bouncedData ? 'bounced' : '',
        isPermanentBounce ? 'isPermanentBounce' : ''
      ]"
		>
			<DeepLink :id="message.id" />

			<md-card-content>
				<div class="email-form">
					<div class="_messageCard">

						<div class="_messageCard__header">
							<md-avatar class="_messageCard__avatar">
								<img src="/img/default-avatar.png" alt="Avatar" />
							</md-avatar>
              <div class="_messageCard__title">
                <md-icon class="_commentCard__type">email</md-icon>
                <span class="_messageCard__author">{{ (message.person && message.person.given_name) ? (message.person.given_name+' '+message.person.family_name) : (message.user && message.user.given_name) ? (message.user.given_name+' '+message.user.family_name) : message.from }}</span>
                <template
                  v-if="(message.replyToMessageId && (message.outgoingFlag == 'reply' || message.outgoingFlag == 'replyAll'))"
                >
                  <strong v-if="bouncedData" class="text-danger">bounced</strong>
                  <strong v-else> replied</strong>
                </template>
                <template v-if="(message.replyToMessageId && message.outgoingFlag == 'forward')">
                  <strong v-if="bouncedData" class="text-danger">bounced</strong>
                  <strong v-else> forwarded</strong>
                </template>
                <span class="_messageCard__time">
                  <md-icon v-if="message.internal">lock</md-icon>
                  <md-icon>schedule</md-icon>
                  {{ timediff(message.createdAt)}}
                </span>
              </div>
						</div>

						<div class="md-layout-item control-btn _messageCard__actions">
							<span class="md-sm md-primary" @click="openReplyForwardEditor(message, 'retry')" v-if="bouncedData && !isPermanentBounce">
								<i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
							</span>
							<span class="md-sm md-primary" @click="openReplyForwardEditor(message, 'reply')">
								<i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">reply</i>
							</span>
							<span class="md-sm md-primary" @click="openReplyForwardEditor(message, 'replyAll')">
								<i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">reply_all</i>
							</span>
							<span class="md-sm md-primary" @click="openReplyForwardEditor(message, 'forward')">
								<i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">forward</i>
							</span>
							<span class="md-sm md-primary" @click="comment(message)" v-if="showCommentButton(message)">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">comment</i>
              </span>
						</div>
					</div>

					<!-- To field -->
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item">
              <label class="md-layout-item md-size-5 md-form-label">
                To:
              </label>
              <span>
                <template>
                  <label>{{ message.to }}</label>
                </template>
              </span>
            </div>
            <div class="md-layout-item control-btn _time">
              <!-- <label>{{'Created ' + timediff(message.createdAt)}}</label> -->
            </div>
          </div>

          <!-- CC field -->
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item">
              <label class="md-layout-item md-size-5 md-form-label">
                CC:
              </label>
              <span>
                <label class="md-layout-item md-size-5 md-form-label">{{ message.cc }}</label>
              </span>
            </div>
          </div>

          <!-- BCC field -->
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item">
              <label class="md-layout-item md-size-5 md-form-label">
                BCC:
              </label>
              <span>
                <label class="md-layout-item md-size-5 md-form-label">{{ message.bcc }}</label>
              </span>
            </div>
          </div>

          <!-- Subject field -->
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item">
              <label class="md-layout-item md-size-5 md-form-label">{{ message.subject }}</label>
            </div>
          </div>

          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item  md-form-label">
              <hr />
            </div>
          </div>
          
          <!-- Body field -->
          <div class="md-layout">
            <!-- <div class="md-layout-item md-size-5 md-form-label"></div> -->
            <div class="md-layout-item">
              <!-- <label class="text-editor-content" v-html='message.body' v-linkified></label> -->
              <CommentBody
                :s3Url="message.s3Url"
                :needsRefresh="message.needsRefresh"
                @refresh="message.body = $event"
              />
            </div>
          </div>
				</div>

        <!-- Actionable attachment icon below message body -->
        <div class="_showAttachment md-layout" v-if="message.messageAttachmentId">
          <md-card-actions md-alignment="left">
            <a
              href="#"
              title="Show/Hide attachment(s)"
              :class="['_showAttachment__toggle', { _on: message.showAttachmentStatus }]"
              @click.prevent="showAttachment(message)"
            >
              <i class="material-icons">attachment</i>
            </a>  
          </md-card-actions>
          
          <!-- Show attachments after clicking on attachment icon -->
          <div class="md-layout-item _showAttachment__body" v-if="message.attachments && message.showAttachmentStatus">
            <!-- <div class="md-layout md-gutter md-alignment-center" v-for="(files,id) in message.attachments" v-bind:key="id">
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(file,id) in files" v-bind:key="id" >
                <div v-if="file.fileName">
                  <span v-if="!file.hasPermission">Internal Members Only</span>
                  <a v-if="file.hasPermission" :href="file.link" download target="_">{{file.fileName}}</a>
                </div>
              </div>
            </div> -->
            <div class="md-layout md-gutter md-alignment-center" v-for="(_attachment, _index) in message.attachments" :key="_index">
              <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                <span v-if="!_attachment.hasPermission">Internal Members Only</span>
                <a v-if="_attachment.hasPermission" :href="_attachment.link" target="_blank">{{_attachment.fileName}}</a>
              </div>
            </div>
          </div>
        </div>	

        <!-- Comment textarea -->
				<div v-if="showCommentBox(message)" class="form-container textarea-container" :id="'comment-'+message.id">
					<div class="dynamicList-loading-comment-spinner" v-show="promisePending">
						<md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
					</div>
          <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="internal">Internal</md-checkbox>
					<TinyMceEditor
            :isComment="true"
						:content="commentModel"
						:mentionArr="userListItems"
						v-model="commentModel"
            @itemSelected="commentItemSelected"
            @success="onUploadSuccess"
					/>
          <div class="md-space-between">
            <md-card-actions md-alignment="left">
              <md-button class="md-simple md-just-icon _attachFileBtn">
                <i class="material-icons" v-on:click="onUpload()">attachment</i>
              </md-button>
              <span v-if="attachmentData == null">Browse or attach file here</span>
              <!-- <div class="md-layout-item" v-if="attachmentData">
                <div class="md-layout md-gutter md-alignment-center">
                  <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                    <div v-show="attachmentData.file.name" class="attchment-card">
                      <div class="attchment-container">{{ attachmentData.file.name }} 
                        <div>{{ attachmentData.description }}</div> ({{ attachmentData.file.size | kb }} kb)
                        <div>{{ attachmentData.type }}</div>
                        <button type="button" class="attachment-button" title="Remove" @click="removeFile()" >x</button>
                      </div>
                      <md-checkbox 
                        class="attachment-area__checkbox" 
                        v-show="$Session && $Session.isInternalGroupMember"
                        v-model="isInternal"
                      >Internal</md-checkbox>
                    </div>
                  </div>
                </div>
              </div> -->
            </md-card-actions>
            <md-card-actions md-alignment="right">
              <md-button
                class="md-sm md-success"
                :disabled="commentModel==''"
                @click="sendComment()"
              >
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Comment
              </md-button>
              <md-button class="md-sm md-danger" @click="cancelComment()">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel
              </md-button>
            </md-card-actions>
          </div>
				</div>

        <!-- MESSAGE COMMENTS -->
	      <CommentList :currentItem="message" :userListItems="userListItems" :caseId="caseId" :atNewComment="atNewComment"></CommentList>
        <div class="_messageCard__body" v-if="message._case">
          <span>Case: </span>
          <span class="_messageCard__author"><a :href="getHref('cases', message._case.id)" target="_self">{{message._case.subject}}</a></span>
        </div>

			</md-card-content>
		</md-card>

    <!-- Upload Dialog -->
    <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
      <md-dialog-title>Attachment</md-dialog-title>
      <md-dialog-content>
        <CommentAttachmentsForm
          :docTypes="docTypes"
          :model="attachmentData"
          @success="onUploadSuccess"
        />
      </md-dialog-content>
    </md-dialog>

		<md-dialog-alert
			:md-active.sync="dialog.status"
			:md-content="dialog.content"
			:md-confirm-text="dialog.confirmText"
			@md-closed="dialog.content = ''"
		/>

    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span>{{ snackbarMsg }}</span>
    </md-snackbar>

  </div>
</template>

<script>
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";

import * as mutations from "@/graphql/mutations";

import accordion from "@/components/Accordion";

import CommentList from "@/components/DynamicForm/CommentList";

// custom email validation for to. cc and bcc
import { CustomEmailValidator } from "@/plugins/vuelidate/custom-email-validator";
// Form validations
import { required } from "vuelidate/lib/validators";

import FilterMessageList from "@/components/DynamicForm/FilterMessageList";

import DeepLink from "@/components/DynamicForm/DeepLink";
import TinyMceEditor from "@/components/Editor/TinyMceEditor";
import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
import CommentBody from '@/components/DynamicForm/CommentBody';
import AttachmentMixin from '@/components/DynamicForm/Attachments/Mixins/AttachmentMixin';

import aws_exports from '@/aws-exports';
const { v4: uuidv4 } = require('uuid');

export default {
  mixins: [AttachmentMixin],
  components: {
    accordion,
    TinyMceEditor,
    CommentList,
    FilterMessageList,
    DeepLink,
    CommentAttachmentsForm,
    CommentBody,
  },
  props: {
    caseId: {
      type: String,
      required: true
    },
    userListItems: {
      type: Array,
      required: true,
      default: []
    },
    atReply: {
      type: Function,
      required: true
		},
		message: {
			type: Object,
			required: true,
    },
    atShowAttachment: {
      type: Function,
      required: true
    },
    manualCase: {
      type: Boolean,
      required: true
    },
    atNewComment: {
      type: Array
    }
  },
  data() {
    return {
      commentMentionList: [],
      cogUserName: null,
      dialog: {
        'status': false,
        'content': "",
        'confirmText': "Ok!"
      },
      // promisePending: false,
      mail: {},
      commentItem: null,
      commentModel: '',
      buttonClicked: {
        reply:false,
        comment: false
      },
      isShowAttachmentOn: false,
      internal: false,
      atMentionsCommentList: [],
      atMentionsUserList: [],
      isSnackbarOpen: false,
      snackbarMsg: '',
    };
  },
  validations() {
    return {
      reply: {
        To: { required, CustomEmailValidator },
        CC: { CustomEmailValidator },
        BCC: { CustomEmailValidator }
      }
    };
  },
  computed: {
    bouncedData() {
      let data = null;
      try {
        data = JSON.parse(this.message.bounces);
      } catch (e) {
        data = null;
      }
      if (data && data.bounce) {
        return data;
      }
      return null;
    },
    isPermanentBounce() {
      const bounceType = this.$reduce(this.bouncedData, 'bounce.bounceType');
      return 'Permanent' == bounceType;
    }
  },
  watch: {
    "$route.hash": function(id) {
      let hashbang = id.substring(1);
      this.isSearchMessageChange(hashbang);
    },
    "reply.Model": function() {
      this.onMessageChange();
    }
  },
  methods: {
    showAttachment: function (message) {
      this.isShowAttachmentOn = !this.isShowAttachmentOn;
      this.atShowAttachment(JSON.parse(JSON.stringify(message)),this.isShowAttachmentOn);
    },
    showCommentBox: function (item) {
      return this.buttonClicked.comment && this.commentItem.id === item.id;
    },
    showCommentButton(item){
      return !this.buttonClicked.comment || this.commentItem.id !== item.id
    },
    getOffset(targetEle) {
      if (!targetEle.getBoundingClientRect) {
        return 0;
      }
      const headerEle = document.querySelector('.md-toolbar');
      let offset = targetEle.getBoundingClientRect().top
      if (headerEle) {
        offset -= headerEle.getBoundingClientRect().height;
      }
      return offset;
    },
    /**
     * ATLAS-1142: <Service-Sidepanel><Deeplink> Deeplink is not working, 
     * Upon clicking it, it is not auto-scrolling to the proper Reply message.
     * @see https://zeamster.atlassian.net/browse/ATLAS-1142
     * Don't scroll if it is the last link in hisotry
     * @returns {Boolean}
     */
    scrollToSidebarElement() {
      const eleSidebar = document.getElementById('sidePanelBody')
      const hash = this.$route.hash.replace('#', '')
      const eleTarget = document.getElementById(hash)
      
      // sidebar, target element or hash does not exists - bail
      if (!eleSidebar || !hash || !eleTarget) {
        return false
      }
      
      // if it the last item in history then bail
      const url = `${window.location.origin}/#${this.$route.fullPath}`
      if (url === this.$Session.deepLinkHistory[0]) {
        return false
      }
      
      // add to history
      this.$Session.deepLinkHistory.unshift(url)
      
      // scroll to element
      parentEle.scrollTo({
        top: this.getOffset(targetEle),
        left: 0,
      })
      
      return true
    },
    isSearchMessageChange(hash) {
      if (this.scrollToSidebarElement()) {
        return
      }

      if (hash) {
        let data = hash.substring(0,7);
        let element = document.getElementById(hash);
        if (element) {
          let top = element.getBoundingClientRect().top + window.pageYOffset;
          if(data === 'comment'){            
             top = top - 100;
          }
          
          // window.scrollTo({
            //   top, // scroll so that the element is at the top of the view
          //   behavior: "smooth" // smooth scroll
          // });
          console.log('Scrolling to target element from Message.vue')
          element.scrollIntoView(true)
        }
      }
    },
    openReplyForwardEditor(item, mode){
      this.buttonClicked.comment = false;
      this.buttonClicked.reply = true;
      this.atReply(mode,JSON.parse(JSON.stringify(item)));     
    },
    comment (item) {
      let id = 'comment-' + item.id;
      setTimeout(() => { this.isSearchMessageChange(id); }, 300);  // ATLAS-652 scrolling to the editor on message comment click
      
      this.mail = null;
      this.buttonClicked.comment = true;
      this.buttonClicked.reply = false;
      this.commentItem = item;
      this.internal = item.internal;
    },
    cancelComment () {
      this.buttonClicked.comment = false;
      this.commentItem = null;
      this.commentModel = '';
      this.internal = false;
      //clean the array
      this.atMentionsUserList.splice(0, this.atMentionsUserList.length);
    },
    async sendComment () {
      //this.placeHolder();
      this.promisePending = true;
      let inputCommentData = {
        internal: this.internal,
        commentMessageId: this.commentItem.id,
        commentUserId: this.$Session.userId
      };
      
      let error = null;
      const s3Key = `comments/${uuidv4()}`;
      const s3Response = await Storage
        .put(s3Key, this.commentModel, {
          bucket: aws_exports.aws_user_files_s3_bucket,
          region: aws_exports.aws_user_files_s3_bucket_region,
        })
        .catch(err => {
          error = err;
          console.log('Error uploading comment to S3', err)
        });
        
      if (error) {
        this.snackbarMsg = error.message || 'Something went wrong. Please try again.';
        this.isSnackbarOpen = true;
        this.promisePending = false;
        return;
      }
      
      inputCommentData.s3Url = s3Key;

      /**
       * ATLAS-877 - Add Updatedby to all Models in the Schema
       * @see https://zeamster.atlassian.net/browse/ATLAS-877
       */
      inputCommentData['commentUpdatedById'] = this.$reduce(this, '$Session.userId');

      //get atMention user data
      this.getAtMentionUsers (this.commentModel);

      //add data for atMentions key
      if (this.atMentionsUserList && this.atMentionsUserList.length) {
        let atMentionsList = {
          items: this.atMentionsUserList
        };
        inputCommentData.atMentions = JSON.stringify(atMentionsList);
      }

      let gqlRequest = graphqlOperation(mutations['createComment'], {input: inputCommentData});
      this.$c.log('gqlRequest', gqlRequest);

      const result = await API.graphql(gqlRequest)
        .then(async result => {
          this.$c.log('***** new comment added ******* ',result);
          
          this.commentMentionList = []
          const newCommentId = result.data.createComment.id;
          const commentUpdatedAt = result.data.createComment.updatedAt
          
          const relations = [
            { fromModelType: 'Comment', relationCommentId: newCommentId },
            { fromModelType: 'Case', relationCaseId: this.caseId }
          ]
          
          this.attachments = this.attachmentData
          await this.add(relations)
          await this.UpdateMessageUpdatedAt(this.commentItem.id, commentUpdatedAt)
          this.cancelComment()
          this.promisePending = false
        })
        .catch(error => {
          this.$c.log('error ', error);
          this.dialog.status = true;
          this.dialog.content = error.errors[0].message;
          this.attachments = []
          this.promisePending = false;
        });
    },
    /**
     * ATLAS-378 Case Comment atMentions
     * Get atMention user data
     */
    commentItemSelected (item) {
      this.atMentionsCommentList.push(item);
    },
    getAtMentionUsers (commentData) {
      this.atMentionsCommentList.forEach(el => {
        if(commentData.includes(el.name)) {
          if(this.atMentionsUserList.indexOf(el.id) == -1) {
            this.atMentionsUserList.push(el.id);
          }
        }
      });
    },
    timediff(updatedDateTimeStamp) {
      let updatedDate = new Date(updatedDateTimeStamp);
      let now = new Date(),
        secondsPast = (now.getTime() - updatedDate.getTime()) / 1000;
      // let displayDate = updatedDate.toLocaleString('default', { month: 'long' }) + " " + updatedDate.getDate() + ", " + updatedDate.getFullYear() + ", " + updatedDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      let displayDate = this.$options.filters.DateFormat(updatedDate)
      
      if (secondsPast < 60) return " Just now " + displayDate;
      if (secondsPast < 3600)
        return parseInt(secondsPast / 60) + " minutes ago " + displayDate;
      if (secondsPast <= 86400)
        return parseInt(secondsPast / 3600) + " hour ago " + displayDate;
      if (secondsPast > 86400)
        return displayDate;      
    },
    getHref(path,id) {
      return '#' + '/'+ path + '/' + id;
    },
    async UpdateMessageUpdatedAt(messageId, updatedAt) {
      let updateInput = {
        id: messageId,
        updatedAt: updatedAt
      }
      let gqlRequest = graphqlOperation(mutations["updateMessage"], {
        input: updateInput
      });
      this.$c.log("gqlRequest for Message update ", gqlRequest);

      const result = await API.graphql(gqlRequest)
        .then(async result => {
          this.$c.log("****** Message updated ******* ",result);
          this.promisePending = false
        })
        .catch(error => {
          this.$c.log("error", error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.md-card-header.list-header.list-header-hidden {
  padding-top: 12px;
}

.dynamicList-loading {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  bottom: auto;
  right: auto;
  display: block;
}

.md-card .md-card-content {
  padding: 3px 15px;
  line-height: 1.75em;
  position: relative;
  min-width: 950px;
}
.md-layout-item {
  margin-top: -12px;
}

.md-card {
  margin: 5px 0px 45px;
}
</style>
<style lang="scss">
#messageListRefresh {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9000;
}

.md-table .md-card.message-viewport {
  width: 100%;
  height: auto;
  margin: 7px 0px 7px 0px;

  &.incoming {
    background-color: rgba(255, 255, 255, 0.38);
  }

  &.outgoing {
    background-color: rgba(240, 248, 255, 1);
  }

  &.note {
    background-color: #fbfae6;
  }
}

#tab-messages .paginated-table .md-table-cell .md-table-cell-container {
  display: block;
}

#tab-messages .md-table-cell-container .md-content {
  background-color: transparent !important;
  display: block;
  width: 100%;
  text-align: left !important;
}
.dynamicList-loading-spinner {
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  right: 0;
  display: block;
  z-index: 9999;
  margin: 0 auto;
  width: 30px;
}
.dynamicList-loading-comment-spinner {
  position: absolute;
  top: 25%;
  left: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  right: 0;
  display: block;
  z-index: 9999;
  margin: 0 auto;
  width: 30px;
}
.form-container {
  position: relative;
}
.email-form {
  .md-field {
    padding-bottom: 0px;
    padding-top: 0;
    margin: 0 0 0 0;
    min-height: auto;
  }
  .md-field:after,
  .md-field:before {
    bottom: 0px;
  }
  .md-input {
    height: 25px;
    padding: 0px 0;
  }
  .md-form-label {
    padding: 0px 5px 0 0 !important;
  }
  .md-title {
    font-size: 14px;
    font-weight: 500;
  }
  .md-avatar {
    border-radius: 50%;
  }
}
.form-container .md-has-textarea {
  border: 0.5px solid #d6d2d2;
}
.textarea-container .md-has-textarea {
  border: 0.5px solid #d6d2d2;
  background: white;
}
label.md-layout-item.md-size-5.md-form-label p {
  text-align: left;
}
.md-layout-item.control-btn {
  text-align: right;
}
.control-btn span {
  padding: 3px;
  cursor: pointer;
}
.md-layout-item hr {
  margin-left: 15px;
}
label.md-layout-item.md-form-label.item-date-lbl {
  font-size: 12px;
}
#messageListPerPage {
  margin-right: 60px;
}
._filter {
  position: absolute;
  top: 30px;
  right: 5px;
}
._feed_item__message ._copy {
  z-index: 1;
  position: absolute;
  top: 0;
  right: 140px;
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.54);
}

input[type="file"] {
  position: absolute;
  top: -1000px;
}
input[type="text"] {
  border: 1px solid #ccc;
  -webkit-border-radius: 4px;
  border-radius: 4px;
}
.attachment-area {
  border: 0.5px solid #c9c0c0;
}
.pointer {
  cursor: pointer;
}
.attchment-card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: auto;
  height: auto;
  white-space: normal;
  background-color: white;
  margin-bottom: 5%;
}
.attchment-container {
  padding: 5px 16px;
  position: relative;
}
.attachment-button {
  position: absolute;
  border-radius: 50%;
  border: 0.5px solid #f5f5f5;
  background-color: rgb(245, 81, 81);
  color: white;
  display: block;
  top: -10px;
  right: -10px;
  cursor: pointer;
}
.tox .tox-collection__item-icon {
  justify-content: flex-start !important;
  width: 100% !important;
}
.tox .tox-collection--grid .tox-collection__item {
  width: 100%;
}
.tox .tox-autocompleter {
  overflow: initial !important;
}
label.md-layout-item.md-size-5.md-form-label p {
  text-align: left;
}
.md-layout-item.control-btn {
  text-align: right;
}
.control-btn span {
  padding: 3px;
  cursor: pointer;
}
.md-layout-item hr {
  margin-left: 15px;
}
label.md-layout-item.md-form-label.item-date-lbl {
  font-size: 12px;
}
#messageListPerPage {
  margin-right: 60px;
}
._filter {
  position: absolute;
  top: 30px;
  right: 5px;
}
._showAttachment__toggle {
  display: inline-block;
  margin-bottom: 0.5rem !important;
  padding: 0 5px;
  background-color: #d2e8f3;
  border-radius: 3px;
  line-height: 1;

  i {
    line-height: 0.75;
  }

  &,
  &:focus,
  &:hover,
  &:active {
    color: #555 !important;
  }
  
  &._on {
    color: #2196f3 !important;
  }
}
 
.outgoing.bounced {
  background-color: #ffe7ef !important;
}

._feed_item__message .bounced:not(.isPermanentBounce) ._copy {
  right: 170px;
}
</style>
